import React from 'react';

const defaultState = {
    fieldList: [],
    registerField: ()=>undefined,
    unregisterField: ()=>undefined
};
const FormCollectionContext = React.createContext(defaultState);

export { FormCollectionContext };
//# sourceMappingURL=FormCollectionContext.js.map
